import React from 'react';  // import the React library
import { Link } from 'react-router-dom'; 
import { motion } from 'framer-motion';
import articleArray from './articleArray.js';

const lifeChargeArray = articleArray.filter(function(article) {
    return article.tag === "Life Charge"});


const lifeChargeTagArray = lifeChargeArray.map(article => 

<li>
<Link to={article.link} style={{textDecoration: "none", color: "black"}}>
<h2>{article.title}</h2>
<div style={{fontSize: "4em", marginBottom: "0px"}}>{article.pic}</div>
<desc>{article.desc}</desc>
</Link>
<br />
<br />
</li>

);


const ArticleListLifeCharge = () => (

<div className="articles">
<motion.div initial="hidden" animate="visible" variants={{
    hidden:{
        scale: .8,
        opacity: 0,
    },
    visible: {
        scale: 1.25,
        opacity: 1,
        paddingBottom: '.2em',
        transition: {
            delay: .6
        }
    },
}}>
<h3 style={{fontSize: '2em'}}>Highway 60 Life Charges:</h3>
<br />
</motion.div>
<ul style={{marginTop: '3em'}}>

{lifeChargeTagArray}

</ul>
</div>
)

export default ArticleListLifeCharge;